module.exports = __webpack_public_path__ + "img/reset-illustration.8895ab77.svg";